import {Loader, Select} from '@mantine/core';
import React from 'react';

import {RoutineSchemaOption} from './routineSchemaSources';

const SELECT_LABEL = 'Select a schema';

interface RoutineSchemaSelectorProps {
  selectedSchemaId: string | null;
  onChange: (update: {schema_id: string | undefined}) => void;
  schemas: Array<RoutineSchemaOption>;
  loading: boolean;
  error: boolean;
  dropdownClassName?: string;
}

export default function RoutineSchemaSelector({
  selectedSchemaId,
  onChange,
  schemas,
  loading,
  error,
  dropdownClassName,
}: RoutineSchemaSelectorProps): JSX.Element {
  const data = schemas.map((schema) => ({value: schema.id, label: schema.name}));

  // Always render the Select (rather than swapping in a separate Loader) so the control keeps a stable
  // layout across loading, loaded, and error states. While loading, show a spinner in the right section.
  return (
    <Select
      data={data}
      value={selectedSchemaId}
      onChange={(value) => {
        onChange({schema_id: value ?? undefined});
      }}
      placeholder={error ? 'Unable to load schemas' : SELECT_LABEL}
      aria-label={SELECT_LABEL}
      disabled={error || loading}
      rightSection={loading ? <Loader size="xs" /> : undefined}
      searchable={true}
      classNames={dropdownClassName != null ? {dropdown: dropdownClassName} : undefined}
    />
  );
}
